module.exports = __webpack_public_path__ + "static/media/image_13.829bfa91.png";